import { reportBeforeRedirectModal } from '@src/utils/report';
import { Trans } from '@src/utils/translate';
import { Modal, Text } from '@tencent/tea-component';
import { LoadingCard } from '@tencent/tpm-trtc-console';
import { useEffect, useRef, useState } from 'react';

interface Props {
  visible: boolean;
  close: () => void;
  url: string;
  target?: string;
}
export default function RedirectModalWrapper(props: Props) {
  const { visible } = props;
  if (!visible) return null;
  return <RedirectModal {...props} />;
}

const RedirectModal = ({ visible, close, url, target = '_blank' }: Props) => {
  const [countdown, setCountdown] = useState(3);
  const [openWindowState, setOpenWindowState] = useState('');
  const redirectTimeId = useRef<any>(null);
  const countTimeId = useRef<any>(null);

  useEffect(() => {
    reportBeforeRedirectModal('Open');
  }, []);

  useEffect(() => {
    redirectTimeId.current = setTimeout(() => {
      const win = window.open(url, target);
      if (!win) {
        reportBeforeRedirectModal('Failed', 'BlockRedirectFailure');
        setOpenWindowState('failed');
      } else {
        reportBeforeRedirectModal('Success', '3s_Success');
        if (target === '_blank') {
          close();
        } else {
          // document.body.innerHTML = '';
          // document.body.style.backgroundColor = 'white';
        }
      }
    }, 3000);

    countTimeId.current = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countTimeId.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearTimeout(redirectTimeId.current);
      clearInterval(countTimeId.current);
    };
  }, [url, target]);

  const onClickRedirectNow = () => {
    reportBeforeRedirectModal('Success', 'ManualRedirect');
    if (target === '_blank') {
      close();
    } else {
      // document.body.innerHTML = '';
      // document.body.style.backgroundColor = 'white';
    }
    clearTimeout(redirectTimeId.current);
    clearInterval(countTimeId.current);
  };

  return (
    <Modal
      visible={visible}
      onClose={close}
      className="trtc-loading-card__dialog"
      maskStyle={{ backgroundColor: 'rgba(12, 17, 26, 0.40)' }}
    >
      <Modal.Body>
        {' '}
        <LoadingCard
          beforeImg={
            <img src="https://cloudcache.tencent-cloud.com/qcloud/ui/static/static_source_business/9498c7eb-87f7-4bdc-a64c-2fabe04e4380.png"></img>
          }
          afterImg={
            <img src="https://cloudcache.tencent-cloud.com/qcloud/ui/static/static_source_business/130e8cd3-5042-4ce0-a7a5-297ad16e2035.png"></img>
          }
          description={
            <>
              {openWindowState === 'failed' ? (
                <>
                  <Trans>
                    Redirection <Text theme="danger">failed</Text>. Tap the
                    button below to continue manually.
                  </Trans>
                </>
              ) : (
                <>
                  <Trans>
                    Redirecting to Tencent Cloud for next steps to complete
                    subsequent operations. Your account and transaction security
                    are ensured.
                  </Trans>{' '}
                  <strong>
                    <>({countdown}s)</>
                  </strong>
                </>
              )}
            </>
          }
          redirect={
            <>
              <a
                href={url}
                target={target}
                className="mr-10"
                onClick={onClickRedirectNow}
              >
                <Trans>Redirect Now</Trans>
              </a>
            </>
          }
        />
      </Modal.Body>
    </Modal>
  );
};
